import {IsObject, IsString} from 'class-validator';

export class ExcelSecondStepRequestDto {
  @IsString()
  key!: string;

  @IsObject()
  columns!: Record<string, string | number>;
}
